var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoUserHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 2C9.60139 2 7.65625 3.94514 7.65625 6.34459C7.65625 8.74404 9.60139 10.6892 12.0008 10.6892C14.4003 10.6892 16.3454 8.74404 16.3454 6.34459C16.3454 3.94514 14.4003 2 12.0008 2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93359 12.189C6.0341 12.189 3.68359 14.5395 3.68359 17.439V18.75C3.68359 19.9926 4.69095 21 5.93359 21H13.3031L11.2478 18.9447C9.50854 17.2054 9.50854 14.3855 11.2478 12.6462C11.4166 12.4774 11.5956 12.325 11.7828 12.189H8.93359Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4856 13.7069C15.3321 12.5534 13.4619 12.5534 12.3085 13.7069C11.155 14.8604 11.155 16.7305 12.3085 17.884L15.3861 20.9617C16.0692 21.6448 17.1766 21.6452 17.8601 20.9626L20.9426 17.8844C22.0961 16.7309 22.0965 14.8604 20.943 13.7069C19.7895 12.5535 17.9194 12.5535 16.7659 13.7069L16.6257 13.8471L16.4856 13.7069Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoUserHeart);
export default __webpack_public_path__ + "static/media/DuoUserHeart.78222aca4fe85e0a44fca5432aedb5c7.svg";
export { ForwardRef as ReactComponent };